import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Star: FC<IIconsProps> = ({
  color = '#FF8D4F',
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90473 1.62571C7.93467 1.53358 8.06501 1.53358 8.09494 1.62571L9.62382 6.33112C9.63721 6.37232 9.6756 6.40022 9.71893 6.40022H14.6665C14.7634 6.40022 14.8036 6.52418 14.7253 6.58112L10.7226 9.48922C10.6876 9.51468 10.6729 9.55982 10.6863 9.60102L12.2152 14.3064C12.2451 14.3986 12.1396 14.4752 12.0613 14.4182L8.05862 11.5101C8.02357 11.4847 7.97611 11.4847 7.94106 11.5101L3.9384 14.4182C3.86003 14.4752 3.75458 14.3986 3.78452 14.3064L5.3134 9.60102C5.32678 9.55982 5.31212 9.51468 5.27707 9.48922L1.27441 6.58112C1.19604 6.52418 1.23632 6.40022 1.33319 6.40022H6.28075C6.32407 6.40022 6.36247 6.37232 6.37585 6.33112L7.90473 1.62571Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Star;
